import "./styles/HowSlide.css";
import { useState, useEffect } from "react";

function HowSlide({ howArr }) {
    const [howIndx, setHowIndx] = useState(0);

    const nextHow = () => {
        if (howIndx === howArr.length - 1) setHowIndx(0);
        else setHowIndx(howIndx + 1)
    };

    const prevHow = () => {
        if (howIndx === 0) setHowIndx(howArr.length - 1);
        else setHowIndx(howIndx - 1)
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (howIndx === howArr.length - 1) setHowIndx(0);
            else setHowIndx(howIndx + 1);
        }, 3000);

        return () => clearInterval(interval);

    }, [howArr.length, howIndx])

    return (
        <div className="how">
            <i
                className="fa-solid fa-chevron-left"
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => prevHow()}
            >
            </i>
            <div className="howMain">
                <div className="howImg">
                    <img src={howArr[howIndx].img} alt="" />
                </div>
                <div className="howInfo">
                    <div className="howTitle">{howArr[howIndx].title}</div>
                    <div className="howDesc">
                        {howArr[howIndx].desc}
                    </div>
                </div>
            </div>
            <i
                className="fa-solid fa-chevron-right"
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => nextHow()}
            >
            </i>
        </div>
    )
}

export default HowSlide;